
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export function Logo() {
  return (
    <div className="flex items-center">
      <img 
        src="/lovable-uploads/2b9a10ce-206c-46a0-9eb6-647c802e433c.png" 
        alt="Corva Logo" 
        className="h-10" 
      />
    </div>
  );
}
